import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

import { AuditLogsComponent } from '@ti/shared/audit/components'
import { AuditLogGridDataResolver } from '@ti/shared/audit/services'

import env from '../../../../env'
import { TspAuditLogGridDataResolver } from '../../services/grid-data.resolver'

@Component({
  selector: 'app-audit-wrapper',
  templateUrl: 'audit-wrapper.component.html',
  styleUrls: ['audit-wrapper.component.scss'],
  providers: [{ provide: AuditLogGridDataResolver, useClass: TspAuditLogGridDataResolver }],
  imports: [AuditLogsComponent, RouterLink, TranslatePipe],
})
export class TspAdminAuditWrapperComponent {
  protected readonly isProduction = env.envType === 'production'
}
